export default {
  pageTitle: "《RO仙境傳説：世界之旅》玩家共創主題頁",
  loginBtn: "請先登入",
  logoutBtn: "[ 登出 ]",
  // activityRule: '活动规则',
  joinActivityText: '已有 <span class="number">${n}</span> 人參加共創活動',
  search: "搜尋",
  searchPlaceholder: "請輸入創作者名稱/關鍵字",
  filter: "篩選",
  sortBy: "排序依據",
  sortByTime: "最新",
  sortByHot: "熱門",
  releaseTime: "發布時間",
  noLimit: "不限",
  oneDay: "一天內",
  oneWeek: "一週內",
  reset: "重設",
  // collapse: '收起',
  loginTip: "完成登入即可參與內容創作",
  nowLoginBtn: "立即登入",
  home: "回到首頁",
  // creative: '创作',
  creativeCenter: "作品管理",
  developmentLog: "研發者日誌",
  feedback: "意見回饋",
  publishTime: "發表時間：",
  selectType: "請選擇類型",
  createType1: "時裝設計",
  createType2: "頭飾設計",
  createType3: `造"梗"活動`,
  createType4: "我的 RO 回憶",
  createType5: "美照分享",
  communicationType1: "意見回饋",
  communicationType2: "研發者日誌",
  inputTitle: "請填寫標題",
  inputContent: "請輸入正文",
  uploadImage: "圖片編輯",
  uploadImageTip: "支援拖曳排序",
  addImage: "新增",
  publish: "我要發佈",
  loading: "載入中",
  publishSuccess: "發表成功，等待審核",
  // publishFail: '发表失败',
  commonTip: "請稍後再試",
  editSaveTip: "這次編輯是否要保留？",
  saveCancel: "不保留",
  saveConfirm: "保留",
  myCreative: "我的創作",
  deleteTip: "刪除這個內容創作？",
  confirmBtn: "確認",
  cancelBtn: "取消",
  auditResultNotice: "審核結果通知",
  auditResultContent:
    "親愛的玩家<br/><br/>您於${time} 發表標題為【${title}】的創作內容審核未通過，請修改後重新上傳",
  auditReason: "未通過原因：",
  auditTime: "審核時間：",
  emptyNotice: "暫無更多內容",
  emptyWorks: "一起來參與共創吧！",
  viewImage: "點擊可查看原圖",
  createPopupTitle: "發布創作",
  gameName: "RO仙境傳説：世界之旅",
  gameType: "首款大世界RO",
  loadingMore: "滑動載入更多",
  noMoreData: "暫無更多內容",
  auditPass: "已發布",
  auditFail: "未通過",
  auditState: "審核中",
  rulePopupTitle: "活動規則",
  overTenTips: "今天發布已經超過10篇啦，明天再來吧～",
  rulePopupContent: ``,
  backText: "返回UGC創作",
  21000: "未登錄",
  21001: "獲取上傳地址失敗",
  21002: "完成文件合併失敗",
  21003: "切片數量無效",
  21004: "上傳ID或上傳路徑不能為空",
  21005: "參數錯誤",
  21006: "提交內容失敗",
  21007: "點贊失敗",
  21008: "清除小紅點失敗",
  21010: "今天發布太多啦，明天再來吧",
  21011: "今天提交次數太多，明天再來吧～",
  21013: "今天提交次數太多，明天再來吧～",
  21014: "郵箱格式不正確",
  21018: "積分不足",
  21019: "抽獎失敗",
  21022: "活動未結束",
  21023: "無可領取的實物獎勵",
  21024: "領取實物獎勵失敗",
  21025: "提交的資料過長",
  21026: "還有剩餘積分可抽獎",
  21027: "沒有可領取的虛擬獎勵",
  21028: "獎勵記錄不存在",
  21029: "獎勵不屬於當前用戶",
  21030: "獎勵類型不是虛擬獎勵",
  21031: "獎勵未領取",
  claimVirtualRewardSuccess: "請至【我的獎品】頁面查看禮包碼",
  submitting: "提交中...",
  submitSuccess: "提交成功！",
  submitFailed: "提交失敗，請重試",
  imageRequired: "必須上傳圖片哦",
  footerProvision: `
    <ol>
        <li>本遊戲內容涉及暴力(武俠動作)、戀愛交友、角色穿著凸顯胸、臂之服節</li>
        <li>本遊戲部份內容需另行支付費用</li>
        <li>請避免沉迷遊戲</li>
    </ol>
  `,
  taskRuleRules:`《RO仙境傳說：世界之旅》玩家UGC活動規則
一、活動時間
2025年10月20日 00:00 - 2026年1月15日00:00。
 
二、積分獲取途徑與規則
1.每日首次登入：5分/次，每日限計1次。
2.事前預約：25分/次，僅計入1次首次預約。
3.加入官方社群帳號，包括Facebook、Discord、Line、YouTube，加入一個平臺的官方帳號可獲得10分，每個平臺限計1次首次加入。
4.參與「意見回饋提交」：15分/次，不限制上傳次數，每天僅首次上傳可獲得積分。
5.參與「我的RO回憶」活動投稿：文字投稿15分/次，圖片投稿25分/次，投稿文字不少於15字，且需為《RO仙境傳說Online》相關內容。每天首次投稿可得分，每週前2次投稿可得分（文字與圖片投稿共用此次數上限）。
6.參與「時裝設計」活動投稿：必須投稿圖片，25分/次，每天首次投稿可得分，限制每週最多1次投稿。
7.參與「美照分享」活動投稿：必須投稿圖片，25分/次，每天首次投稿可得分，限制每週最多2次投稿。
8.為他人作品按贊：0.5分/贊，每個作品僅計一次有效按讚，取消後再按贊不可再次得分，每日僅限前10個有效按贊可獲得積分。
9.作品獲得他人按贊：1分/贊，為防止惡意刷分，單一帳號每週透過此途徑獲得的積分上限為200個有效按贊（即200分）。
10. 按贊帳號需為活躍有效帳號，官方系統將偵測異常按贊模式，官方保留因作弊行為（包含但不限於自按贊、互刷群組等）取消異常積分之權利。
11.上述每日刷新參與次數的活動均于每日淩晨00:00刷新，每週參與次數的活動均於每週一00:00刷新。
 
三、積分抽獎規則
玩家於活動期間參與共創活動獲得積分，每25積分可兌換一次抽獎機會，每250積分可進行一次十連抽獎。積分僅限於抽獎活動期間內使用，逾期失效。
虚宝包括遊戲中稱號、頭像框、頭飾，實物獎品包括手機支架、帆布包、冰箱貼、萬年曆及腰靠，抽獎概率為：
未中獎79%
游戏道具稱號10.0%
游戏道具頭像框10.0%
实物周边巴風特手機支架0.5%
实物周边大世界帆布包0.23%
实物周边初心者裝死冰箱貼0.13%
实物周边波利萬年曆0.1%
实物周边RO職業腰靠0.03%
游戏道具頭飾0.01%
 
四、獎品領取相關規則
1.獎品領取時間：游戲公測后，具體時間後續版本會更新至頁面。
2.虛寶領取規則：
1）用戶在活動中抽到的虛寶，可在「查看獎品」頁面中統一查看。
2）活動期間頁面上的領取按鈕無效，會透過文案提示用戶在公測後回到該頁面，獎勵領取功能將在遊戲公測後開放。
3）遊戲公測後，用戶可在活動頁面查看所獲獎品的對應禮包碼，使用禮包碼在遊戲中兌換虛寶。
3.實物獎品領取規則：
1）中獎玩家必須於公測后30個工作日內，在活動頁面填寫完整且正確的收件資訊（拒絕提供或逾期提供，視為自動放棄領獎資格）。
2）收件資訊填寫要求：①真實姓名 ②有效手機號碼 ③詳細至門牌號的有效收件地址。請玩家務必仔細核對資訊正確性。因資訊填寫錯誤、不全或收件人無法聯繫導致物流失敗、獎品遺失或退回者，官方恕不補發、不賠償，亦不承擔任何責任。您所提供的個人資料，僅供本次活動獎品寄送及相關行政作業之用，主辦單位將依相關法令規定善盡保密責任。
3）實物獎品時間： 預計於活動結束後30至60個工作天內陸續發貨完畢，請耐心等候。
4）請特別注意，本活動僅面向遊戲發行區域，即香港、澳門、臺灣。中獎玩家填寫的收件地址不能超出上述區域範圍，否則視為放棄實物獎品。
 
五、玩家責任與棄權條款：
1.請玩家密切關注本活動規則及各項時限（包含活動期間、積分獲取與兌換期間、地址填寫截止日、虛擬獎品領取期間等），若玩家未於官方指定之規則時間內參與活動、兌換抽獎機會、填寫收件地址或領取虛擬獎品，一律視為玩家自動放棄相關權益。
2.因前述棄權行為導致之所有損失（包含但不限於積分失效、獎品無法領取等），概由玩家自行承擔，官方無須給予任何形式之補償或恢復。

六、作品版權與使用說明
您於投稿時即同意授予遊戲官方一項全球範圍內、永久、不可撤回且免權利金之授權，用於遊戲內外及相關行銷、宣傳、改作及衍生利用。官方有權對該您的投稿內容進行必要的修改、優化、製作、重製，並應用於遊戲內、遊戲周邊商品、市場推廣等相關活動中。
 
七、反作弊機制
1.官方將嚴密監控活動參與行為，一旦監測到以下違規行為，將立即採取包括但不限於封鎖涉事帳號、撤銷其所有活動資格、追回已發放之獎勵（含已使用虛擬道具）及追究法律責任之權利：
2.使用任何方式進行批量註冊小號（同人、同設備、同IP多帳號等）參與活動。
3.利用程式漏洞、非官方提供之工具或任何非正常手段刷取積分。
4.使用非法第三方軟體、外掛或輔助工具干擾活動。
5.任何形式的自按贊、互刷贊、買贊等異常或虛假互動行為。
6.提供虛假個人資訊或盜用他人資訊。
7.其他經官方認定違反活動公平性、損害遊戲環境之行為。
 
八、不可抗力條款
如遇以下不可歸責於官方之不可抗力因素（包含但不限於：政府政策法令變更、氣象災害、疫情、戰爭等），官方保留調整活動時間的權利：視情況延長、縮短或暫停活動，並將於遊戲官網或粉絲專頁至少提前24小時公告。如遇突發不可抗力（包含但不限於：重大伺服器故障、駭客攻擊等），無法提前公告時，官方承諾於第一時間儘快公告。
 
九、免責聲明
參與本活動即表示您已充分閱讀、理解並同意以下事項：
1.若您為未成年人或限制行為能力人，您已經得到法定代理人同意後才參加本活動。
2.時效棄權： 未在官方指定之各項規則時間內（積分兌換期、地址填寫截止日、虛擬獎品領取期等）完成必要操作，一律視為自動放棄相關權益。
3.資訊錯誤責任：因玩家提供之個人資訊（包含但不限於收件資訊、帳號資訊）錯誤、不實、失效或未及時更新，導致無法獲得積分、無法參與抽獎、獎品無法送達、虛擬獎品無法發放或任何損失，官方概不負責。
4.帳號安全與狀態責任： 因玩家帳號遭盜用、個人設備問題、網路環境問題、未遵守遊戲規章導致帳號遭封停等因素，造成無法參與活動、積分損失、獎品無法領取或任何損失，官方概不負責。活動期間若帳號遭封停，其未使用之積分及未發放之獎勵將自動失效作廢。
5.系統記錄為准：所有積分獲取、消耗、抽獎記錄、中獎記錄等，均以官方系統後臺記錄為最終依據。
 
※ 活動最終解釋權歸《RO仙境傳說：世界之旅》遊戲官方所有。官方有權根據活動實際情況，在法律允許範圍內對本規則進行補充、修改或變更，並於官方管道公告後生效。
`,
rulePopupContent: `《RO仙境傳說：世界之旅》玩家時裝設計活動規則
 
一、活動時間
1.投稿時間：2025年11月4日 00:00 - 2025年12月18日 23:59。
2.入選作品公佈期：2025年12月19日 16:00 - 2025年12月22日 23:59。（同時於Facebook等官方社群平臺公告）。
 
二、活動玩法
玩家可對頁面展示的作品進行按贊。活動結束時，獲得最高「按贊數」的作品即為優勝作品，將由官方進行優化設計，實裝進遊戲中並贈送給玩家。
 
三、參與方式
1.投稿平臺：請在共創活動網頁上傳您的圖片作品。
2.圖片投稿格式：
1）請提交PNG或JPG格式的圖片。
2）圖片大小請勿超過5MB。
3.請確保圖片清晰，主題明確，包含正面視角的男女對應時裝。
 
四、參與規則
1.原創性要求：作品必須為參與者本人原創，嚴禁抄襲、盜用他人作品或使用未經合法授權或有權利瑕疵之任何素材。一經發現，將立即取消參賽資格。
2.內容規範：
1）作品內容不得涉及色情、暴力、賭博、政治、宗教歧視或任何違反公序良俗之元素。
2）作品不得包含任何受第三方智慧財產權保護之內容（如其他遊戲角色、動漫人物、商標Logo等）。若使用開源素材或已獲授權之素材，須于投稿時一併提供授權證明。
3）作品不得包含現實世界可辨識之人物肖像，除非您已獲得該肖像權人明確之使用授權並可提供證明。
3.反作弊機制：
1）禁止任何形式的刷票行為，包括但不限於：使用機器人帳號、付費買票、加入互刷群組、以及其他任何試圖人工操縱投票（按贊）結果之不正當行為。
2）官方將透過系統監測與人工審核等方式嚴查作弊行為。一經查實，將立即取消涉事作品之參賽資格與所有得票數，並視情況對相關帳號進行處分。
3）所有票數均以官方後臺最終統計結果為准。
 
五、獲獎作品版權與使用說明
1.您于投稿時即同意授予遊戲官方一項全球範圍內、永久、不可撤回且免權利金之授權，官方於活動期間內，為遊戲宣傳、活動宣傳、展示、投票之目的，於活動網頁及相關平臺使用您作品之權利。
2.入選作品：
若您的作品獲選（被選中植入遊戲），您同意將該設計之智慧財產權，授予遊戲官方得用於遊戲內外及相關行銷、宣傳、改作及衍生利用。原作者仍保有作品著作權，但不得再將該作品授權予任何第三方使用。官方有權對該設計進行必要的修改、優化、製作、重制，並應用於遊戲內、遊戲周邊商品、市場推廣等相關活動中。獲獎者將享有署名權，官方將在遊戲內合適位置標注設計者的遊戲ID或您指定的昵稱（長度需符合遊戲規範）。
2.未入選作品：
未獲選之作品，其相關智慧財產權亦仍歸原作者所有。
 
六、隱私權保護
1.您因參與本活動而提供之個人資料（如聯繫資訊），官方將依相關規定進行處理與保護，僅用於活動相關用途（如身份驗證、活動通知、獎品發放等）。
2.本活動由【Gravity Game Vision】搜集您的個人資料，搜集目的為活動聯絡與獎品寄送。您的個人資料將於活動結束後保存【1年】，僅限於中華民國境內使用，且不會提供予第三人。依個資法規定，您得向主辦單位行使查詢、更正、刪除您提供之個人資料之權利。
 
七、評選方式
1.官方初審：官方會篩除違反活動規章或不符合投稿格式要求的作品。所有通過審核的作品均會於活動頁面中公開展示。
2.玩家投票：通過初審的作品將於活動專題頁面展示，玩家可自由進行按贊，最終獲得按贊數最高的作品，將被選定為本次活動的優勝作品。
 
八、製作與發放說明
1.製作週期：優勝設計被選中後，需經過官方美術團隊的精細化建模、貼圖製作、技術適配及品質打磨等開發流程。此過程需要必要的製作時間，具體時程將視設計複雜度及整體開發排期而定。
2.品質保證與修改權：官方保留根據遊戲技術實現、整體美術風格統一性、遊戲平衡性等因素，對入選設計進行必要且合理修改與優化的權利。最終遊戲內呈現效果以官方實際製作版本為准。
3.發放時間：該道具將在製作完成並通過最終驗收後，於遊戲公開測試（OBT）版本中正式發放給所有玩家。優勝設計者將于道具上線前收到官方通知。
 
九、免責聲明
若因不可抗力因素（如網路攻擊、重大系統故障、自然災害等）導致活動無法順利進行，官方保留調整、延遲或終止活動之權利，並將儘快於官方管道公告。官方保留根據實際情況，在法律允許範圍內對本活動規則未盡事宜進行補充、修改之權利。任何變更將於官方平臺公告後生效。
 
※ 活動最終解釋權歸《RO仙境傳說：世界之旅》遊戲官方所有。官方有權根據活動實際情況，在法律允許範圍內對本規則進行補充、修改或變更，並於官方管道公告後生效。
`,
createPopupTip: '本人知悉並同意：您於投稿時即同意授予遊戲官方一項全球範圍內、永久、不可撤回且免權利金之授權，用於遊戲內外及相關行銷、宣傳、改作及衍生利用。'
};

